import React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Home from "./pages/home/home";
import CompanyProfile from "./pages/us/aboutUs";
import OurProducts from "./pages/OurProduct/ourProduct";
import Product1 from "./pages/product1/product1";
import Product2 from "./pages/product2/product2";
import Product3 from "./pages/produck3/product3";
import ContactUs from "./pages/contact/contactUs";
import Blog from "./pages/Blog/Blog";

// Variabel untuk animasi halaman
const pageVariants = {
  initial: { opacity: 0, x: 50 }, // Memulai dengan opacity 0 dan posisi x +50
  animate: { opacity: 1, x: 0, transition: { duration: 0.5, ease: "easeInOut" } }, // Fade in dan bergerak ke posisi normal
  exit: { opacity: 0, x: -50, transition: { duration: 0.3, ease: "easeInOut" } }, // Keluar dengan fade dan geser sedikit
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Navigate to="/home" />} />
        
        <Route
          path="/home"
          element={
            <motion.div
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <Home />
            </motion.div>
          }
        />
        <Route
          path="/company-profile"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <CompanyProfile />
            </motion.div>
          }
        />
        <Route
          path="/our-products"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <OurProducts />
            </motion.div>
          }
        />
        <Route
          path="/product-1"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <Product1 />
            </motion.div>
          }
        />
        <Route
          path="/product-2"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <Product2 />
            </motion.div>
          }
        />
        <Route
          path="/product-3"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <Product3 />
            </motion.div>
          }
        />
        <Route
          path="/contact-us"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <ContactUs />
            </motion.div>
          }
        />
        <Route
          path="/blog"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <Blog />
            </motion.div>
          }
        />
        <Route path="*" element={<Navigate to="/home" />} />d
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
